module.exports = __webpack_public_path__ + "img/header-historico.31b3a881.jpg";